module.exports = __webpack_public_path__ + "img/persons-clap.1a2c07d2.png";